import React from "react";
import { motion } from "framer-motion";
import { DraftingCompass, Sofa, House } from "lucide-react";
import { useLanguage } from "../i18n";

const ICONS = [DraftingCompass, Sofa, House];

export const Audience = () => {
  const { t } = useLanguage();
  const a = t.audience;
  return (
    <section data-testid="home-audience" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div className="max-w-2xl mx-auto text-center" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amberdark mb-6">{a.overline}</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight leading-tight text-ink">{a.title}</h2>
        </motion.div>
        <div className="mt-14 grid md:grid-cols-3 gap-10 md:gap-8">
          {a.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={item.title} data-testid={`home-audience-${i}`} className="text-center px-2"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.5, delay: i * 0.08 }}>
                <Icon className="w-10 h-10 mx-auto text-ink" strokeWidth={1.5} />
                <h3 className="mt-6 text-sm uppercase tracking-[0.25em] font-semibold text-ink">{item.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-inksoft max-w-xs mx-auto">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
